import React, { Component } from 'react';
import {Link}from 'react-router-dom';
import ReactDOM from 'react-dom';

// images

import InfoJumb1 from './images/infoJumbo1.jpg';
import InfoJumb2 from './images/infoJumbo2.jpg';
import InfoJumb3 from './images/infoJumbo3.png';
import banner1 from './images/banner1.jpg';

import {Grid, Row, Col, Carousel, Breadcrumb, Button} from 'react-bootstrap';

class Almi extends Component {

  render() {
    return (
      <div className='container-fluid'>
        <div className="supMainLS">
          <div className="BC">
          <Breadcrumb className='breadcrumb-item'>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item >
              <Link to="/Suppliers">Lieferanten</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
                <Link to="/Suppliers/SuB">SuB</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item active>Almi</Breadcrumb.Item>
          </Breadcrumb>
          </div>
          <img src={banner1} alt="Almi Headquater" />
        </div>
        <div className="supMainTextLS">
          <h1>Almi</h1>
          <Grid className="supMainInfo">
            <Row>
              <Col xsHidden smHidden md={5}>
                <Carousel  controls={false} interval={3000}>
                  <Carousel.Item >
                      <img  src={InfoJumb1}  alt="Almi AL100U-02"  height="100%" />
                  </Carousel.Item>
                  <Carousel.Item>
                      <img  src={InfoJumb2} alt="Almi AL1"  height="100%"/>
                  </Carousel.Item>
                  <Carousel.Item>
                      <img  src={InfoJumb3} alt="Almi AL1-2E"  height="100%" />
                  </Carousel.Item>
                </Carousel>
                </Col>
              <Col xsHidden md={7}>
                <h4>ALMI ist international tätig mit einer breiten Palette an Steinschneidern, Rohrschneidern und Rohrklinkern.
                Diese Produkte werden weltweit über ein umfangreiches Händlernetz vertrieben. Diese Kombination aus eigenen Endprodukten und der Belieferung von OEM-Unternehmen bietet ALMI die Möglichkeit, seine Mitarbeiter und Vermögenswerte effizient einzusetzen.
                Durch die schlanke Organisation der Produktionsprozesse und der Logistik kann ALMI seinen Kunden ein Höchstmaß an Flexibilität bieten.
                ALMI Rohrausschleifer bieten Ihnen einen Mehrwert durch die Gewissheit, dass Sie jahrelang problemlos, präzise und schnell Rohre bearbeiten können.
              </h4>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>
                <h4>ALMI ist international tätig mit einer breiten Palette an Steinschneidern, Rohrschneidern und Rohrklinkern.
                Diese Produkte werden weltweit über ein umfangreiches Händlernetz vertrieben. Diese Kombination aus eigenen Endprodukten und der Belieferung von OEM-Unternehmen bietet ALMI die Möglichkeit, seine Mitarbeiter und Vermögenswerte effizient einzusetzen.
                </h4>
              </Col>
              <Col xs={12} md={{ span: 7, offset: 2 }}>
                <Button className="supMainButtonWebPage" variant="light" href="https://www.almi.nl/de/" target="_blank">Hersteller Homepage</Button>
              </Col>
            </Row>
          </Grid>
        </div>
        <br/>
        <section>
        <div className="supMainKeyWords">
          <br/>
          <Grid>
            <Row>
              <Col xsHidden  sm={4} md={2}>

                <h5>Robuste Bauform</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                  <h5>Innovative hochgenaue Fertigung</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                    <h5>Wartungsfreundlich</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                    <h5>3 Jahre Herstellergarantie</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                    <h5>Made in Netherlands</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                    <h5>Ressourcenschonende Technik</h5>
              </Col>

            </Row>
            <br/>
            <Row className="show-grid">
              <Col xs={12}  smHidden mdHidden lgHidden>

                <h5>&#9658; &nbsp; Robuste Bauform</h5>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>

                  <h5>&#9658; &nbsp; Innovative hochgenaue Fertigung</h5>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>

                    <h5>&#9658; &nbsp; Wartungsfreundlich</h5>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>

                    <h5>&#9658; &nbsp; 3 Jahre Herstellergarantie</h5>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>

                    <h5>&#9658; &nbsp; Made in Netherlands</h5>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>

                    <h5>&#9658; &nbsp; Ressourcenschonende Technik</h5>
              </Col>


            </Row>
          </Grid>
          <br/>
        </div>
        </section>
        <section>

        <Grid className="gridUp">
          <center>
          <h1>Produkte</h1>
          </center>
          <Row className="show-grid">
            <Col  xs={12} sm={12}>
              <center>
              <Link to="/Suppliers/Almi/PipeGrinders"><h4 className="buttonBlue">Rohrausschleifer/-klinker</h4></Link>
            </center>
            </Col>
          </Row>

        </Grid>
        <br/>
      </section>
        </div>
    );
  }
}

export default Almi;



// WEBPACK FOOTER //
// ./src/components/pages/supplier/Almi/mainPageSup.js